<div class="followed-producers-section">
  <div class="title-area">
    <h2>Produtores que você segue</h2>
  </div>

  <div class="producers-area">
    @if (followedProducers) {
      @if (followedProducers.length > 0) {
        <p-carousel
          [value]="followedProducers"
          [numVisible]="4"
          [numScroll]="1"
          [responsiveOptions]="responsiveOptions">
          <ng-template let-producer pTemplate="item">
            <div class="m-2">
              <app-producer-card [producer]="producer" />
            </div>
          </ng-template>
        </p-carousel>
      } @else {
        <p>Você ainda não segue nenhum produtor</p>
      }
    } @else {
      <div class="loading-grid">
        <div class="load-element">
          <p-skeleton shape="circle" size="150px" />
          <p-skeleton height="2rem" />
        </div>
        <div class="load-element">
          <p-skeleton shape="circle" size="150px" />
          <p-skeleton height="2rem" />
        </div>
        <div class="load-element">
          <p-skeleton shape="circle" size="150px" />
          <p-skeleton height="2rem" />
        </div>
        <div class="load-element">
          <p-skeleton shape="circle" size="150px" />
          <p-skeleton height="2rem" />
        </div>
      </div>
    }
  </div>
</div>
